<template>
  <div class="viq-msg-user">
    <div class="viq-msg-user__avatar">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M8 8a3 3 0 100-6 3 3 0 000 6zm0 1.5c-3 0-5.5 1.5-5.5 3V14h11v-1.5c0-1.5-2.5-3-5.5-3z" fill="currentColor" />
      </svg>
    </div>
    <div class="viq-msg-user__bubble">
      <p class="viq-msg-user__text">{{ message.content }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ViqMessageUser",
  props: {
    message: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/viq.scss";

.viq-msg-user {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  gap: $viq-space-sm;
  padding: $viq-space-sm 0;
  width: 100%;

  &__avatar {
    order: 1;
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: rgb(27, 42, 61);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__bubble {
    max-width: 75%;
    background: rgb(27, 42, 61);
    color: #fff;
    border-radius: $viq-radius-lg $viq-radius-lg $viq-radius-sm $viq-radius-lg;
    padding: $viq-space-md;
  }

  &__text {
    margin: 0;
    font-size: $viq-font-base;
    line-height: 1.5;
    white-space: pre-wrap;
    word-break: break-word;
  }
}
</style>
